

export const environment = {
  production: true,
  apiBaseUrls: "https://bloom-admin-api.redianglobal.com/",
  ImageBaseUrls: "https://bloom-admin-api.redianglobal.com/"
};

/*
  URL : http://155.248.248.199:4208
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
